if (!customElements.get('brand-collection-slider')) {
  class BrandCollectionSlider extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('.brand-collection__viewport');
      this.track = this.querySelector('.brand-collection__track');
      this.slides = [...this.track.querySelectorAll('.brand-collection__slide')];
      this.prevBtn = this.querySelector('.brand-collection__btn--prev');
      this.nextBtn = this.querySelector('.brand-collection__btn--next');
      this.currentIndex = 0;

      if (this.slides.length <= 1) return;

      this.prevBtn?.addEventListener('click', () => this._go(this.currentIndex - 1));
      this.nextBtn?.addEventListener('click', () => this._go(this.currentIndex + 1));

      this._initSwipe();
      this._update();
    }

    _go(index) {
      this.currentIndex = Math.max(0, Math.min(index, this.slides.length - 1));
      this.track.style.transform = `translateX(-${this.currentIndex * 100}%)`;
      this._update();
    }

    _update() {
      if (this.prevBtn) this.prevBtn.disabled = this.currentIndex === 0;
      if (this.nextBtn) this.nextBtn.disabled = this.currentIndex >= this.slides.length - 1;
    }

    _initSwipe() {
      let startX = 0;
      let startY = 0;
      let tracking = false;

      this.viewport.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        tracking = true;
      }, { passive: true });

      this.viewport.addEventListener('touchend', (e) => {
        if (!tracking) return;
        tracking = false;
        const dx = startX - e.changedTouches[0].clientX;
        const dy = startY - e.changedTouches[0].clientY;
        if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 40) {
          dx > 0 ? this._go(this.currentIndex + 1) : this._go(this.currentIndex - 1);
        }
      }, { passive: true });

      this.viewport.addEventListener('touchmove', (e) => {
        if (!tracking) return;
        const dx = Math.abs(startX - e.touches[0].clientX);
        const dy = Math.abs(startY - e.touches[0].clientY);
        if (dx > dy) e.preventDefault();
      }, { passive: false });
    }
  }

  customElements.define('brand-collection-slider', BrandCollectionSlider);
}
